import Swiper, {Autoplay, Navigation, Thumbs} from "swiper";

export default () => {
  let swiperProductThumbs = new Swiper(".p-project-gallery-thumbs", {
    spaceBetween: 6,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
  });

  new Swiper(".p-project-gallery-main", {
    modules: [Thumbs, Navigation, Autoplay],
    spaceBetween: 10,
    loop: true,
    loopedSlides: 6,
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiperProductThumbs,
    },
  });
}
